import React from "react";
import { Navigate } from "react-router-dom";
import Main from "./layout/Main";

import { useAuthContext } from "../context/AuthContext";
const PrivateRoute = ({ children }) => {

  const { isLoggedIn, authLoading } = useAuthContext()

  if (authLoading) return null;

  return isLoggedIn ? (
    <>
      <Main>{children}</Main>
    </>
  ) : (
    <Navigate to="/login" />
  );
};

export default PrivateRoute;
